import { render, staticRenderFns } from "./DialogModelCreateOrder.vue?vue&type=template&id=5531e5c0"
import script from "./DialogModelCreateOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogModelCreateOrder.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports